import type { MeetingRange } from "@/types/api"

/** Local calendar date as YYYY-MM-DD (no UTC shift, unlike toISOString). */
export function toIsoDate(date: Date): string {
  const y = date.getFullYear()
  const m = String(date.getMonth() + 1).padStart(2, "0")
  const d = String(date.getDate()).padStart(2, "0")
  return `${y}-${m}-${d}`
}

export function parseIsoDate(value: string): Date {
  const [y, m, d] = value.split("-").map(Number)
  return new Date(y, m - 1, d)
}

/** Monday-first grid for one month: leading blanks as null, then each day of the month. */
export function monthGrid(year: number, month: number): (Date | null)[] {
  const first = new Date(year, month, 1)
  const leading = (first.getDay() + 6) % 7
  const days = new Date(year, month + 1, 0).getDate()
  const cells: (Date | null)[] = Array.from({ length: leading }, () => null)
  for (let day = 1; day <= days; day++) cells.push(new Date(year, month, day))
  while (cells.length % 7 !== 0) cells.push(null)
  return cells
}

/**
 * Applies one click to a pending range. The first click sets the start; the second
 * sets the end (swapped if earlier than the start). A click after a complete range
 * starts a new one.
 */
export function applyClick(
  pending: { start: string | null; end: string | null },
  clicked: string,
): { start: string | null; end: string | null } {
  if (!pending.start || pending.end) return { start: clicked, end: null }
  if (clicked < pending.start) return { start: clicked, end: pending.start }
  return { start: pending.start, end: clicked }
}

export function toMeetingRange(pending: { start: string | null; end: string | null }): MeetingRange | null {
  if (!pending.start) return null
  return { start_date: pending.start, end_date: pending.end ?? pending.start }
}
